module.exports = __webpack_public_path__ + "static/media/screenshot_error.d1c107f9.svg";